import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  const scrollToPurchase = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('purchase')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={scrollToPurchase} className={cn(`bg-[#22c55e] text-white py-5 px-8 rounded-2xl font-black text-lg shadow-lg shadow-[#22c55e]/20 hover:bg-[#16a34a] transition-all uppercase tracking-wider flex items-center justify-center gap-3 w-full max-w-md mx-auto ${className}`, 'pl-[32px] pr-[32px] ml-[0px] mr-[0px]')} data-id="element-54">
      QUIERO MI ACCESO
      <ArrowRight size={20} data-id="element-55" />
    </motion.button>;
}